



























































import APP_CONST from '@/constants/AppConst';
import { ICreateUser } from '@/Model/programModel';
import { checkEmailExist } from '@/services/userService/users-api';
import commonEntry from '@/store/modules/commonEntry';
import { Component, Mixins } from 'vue-property-decorator';
import LoginRightIllustration from '../../commonComponents/loginRightIllustration/LoginRightIllustration.vue';
import AccountSettings from '@/mixins/accountSettings.mixin';

import { ScreenText } from '@/lang/ScreenText';

@Component({
  components: {
    'right-illustration': LoginRightIllustration
  }
})
export default class RegisterWithEmail extends Mixins(AccountSettings) {

  public guardianInfo: ICreateUser = JSON.parse(JSON.stringify(APP_CONST.USER_CREATION));
  public emailCheck: boolean | string = '';
  public isValidEmail: boolean | string = '';
  public accountNotFound: boolean | string = '';
  public alreadyAddedUser: boolean | string = '';
  public registerUserResponse: boolean = true;
  public screenText: ScreenText = new ScreenText();

  public emailFocus() {
    this.isValidEmail = true;
    this.emailCheck = false;
  }

  get accountName(): string {
    return commonEntry.accountDesignDetails.accountName;
  }

  validateEmail(mail: string) {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(mail);
  }

  async submit() {
    /* istanbul ignore else */
    if (!this.guardianInfo.email) {
      this.emailCheck = true;
      return;
    }
    if (!this.registerUserResponse) {
      return;
    }
    this.registerUserResponse = false;
    this.emailCheck = false;
    this.accountNotFound = false;
    this.alreadyAddedUser = false;
    const email = this.guardianInfo.email
      ? this.guardianInfo.email.trim()
      : this.guardianInfo.email;
    this.isValidEmail = this.validateEmail(email);
    /* istanbul ignore next */
    if (this.isValidEmail) {
      this.guardianInfo.userRoles[APP_CONST.ZERO].accountId = commonEntry.accountDesignDetails.accountId;
      this.guardianInfo.userRoles[APP_CONST.ZERO].roleId = this.guardianInfo.userRoles[APP_CONST.ZERO] && APP_CONST.ROLE_TYPE_GUARDIAN;
      commonEntry.mutateEmail(this.guardianInfo);
      const response = await checkEmailExist(this.guardianInfo);
      /* istanbul ignore else */
      this.registerUserResponse = true;
      if (response.status == APP_CONST.RESPONSE_200) {
        window.location.href = response.data;
      }
      if (response.status == APP_CONST.RESPONSE_400 && response.data.name == 'Error_UserEmail') {
        // XXX this appears to only be triggered when the given email is associated with a non-guardian account
        // TODO change the error message maybe?
        this.accountNotFound = true;
      }
      else if (response.status == APP_CONST.RESPONSE_409) {
        this.$router.push(APP_CONST.APP_ROUTES.LOGIN);
      }
    }
    else {
      this.registerUserResponse = true;
      return;
    }
  }

}
